var $f4b5b80fed008d49$exports = {};
$f4b5b80fed008d49$exports = {
  "collapse": "Reduzieren",
  "expand": "Erweitern"
};
export { $f4b5b80fed008d49$exports as default };